// Advance Search JS

document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('search-query');
  const btn = document.getElementById('search-btn');

  if (!input || !btn) return;

  btn.disabled = true;

  input.addEventListener('input', () => {
    btn.disabled = input.value.trim().length === 0;
  });
});

// Flickity Search JS
if(document.body.classList.contains('template-index')){
setTimeout(function() {
var flkty = new Flickity('.custom-product-slider.custom-video-slider.shop-all-left .custom-video-slider', {
    cellAlign: 'left',
    contain: false,
    pageDots: false,
    prevNextButtons: true,
    groupCells: false,
    wrapAround: true
});
},2000);

setTimeout(function() {
var flkty2 = new Flickity('.custom-image-slider.shop-all-right .custom-image-slider-wrapper', {
    cellAlign: 'left',
    contain: false,
    pageDots: false,
    prevNextButtons: true,
    groupCells: false,
    wrapAround: false
});
},2000);
}

// Placeholder Change JS

(function () {
  const phrases = ["Shirts", "Black Top", "Coord Sets", "Blue Dress"];
  const input = document.getElementById("search-query");

  if (!input) return;

  let index = 0;
  let intervalId = null;

  function rotatePlaceholder() {
    if (document.activeElement === input && input.value.length > 0) return;

    input.setAttribute("placeholder", phrases[index]);
    index = (index + 1) % phrases.length;
  }

  if (!input.dataset.placeholderInterval) {
    rotatePlaceholder();
    intervalId = setInterval(rotatePlaceholder, 3000);
    input.dataset.placeholderInterval = "true";
  }

  input.addEventListener("focus", () => {
    if (intervalId) clearInterval(intervalId);
  });

  input.addEventListener("blur", () => {
    if (!intervalId) {
      intervalId = setInterval(rotatePlaceholder, 3000);
    }
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  const topLink = document.querySelector(".top-link");

  if (!topLink) return;

  topLink.addEventListener("click", function (e) {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-content-main");

  tabs.forEach(tab => {
    const content = tab.querySelector(".tab-content-inner");

    if (!content) {
      tab.style.display = "none";
      return;
    }

    // Extract real visible text
    const text = content.textContent
      .replace(/\u00A0/g, "") // remove &nbsp;
      .replace(/\s+/g, "")    // remove all whitespace
      .trim();

    if (text.length === 0) {
      tab.style.display = "none";
    }
  });
});



// collection js

if (
  document.body.classList.contains('template-collection') ||
  document.body.classList.contains('template-search')
) { 
  document.addEventListener("DOMContentLoaded", function () {

  let flickityInstance = null;
  let initTimeout = null;

  const quickViewButtons = document.querySelectorAll(".gitem a.btn.quick-view");

  if (!quickViewButtons.length) return;

  quickViewButtons.forEach(button => {

    button.addEventListener("click", function () {

      // Clear previous timeout if user clicks multiple times fast
      if (initTimeout) {
        clearTimeout(initTimeout);
      }

      initTimeout = setTimeout(function () {

        const slider = document.querySelector("#pisquick-view");
        if (!slider) return;

        // If already initialized, destroy first (safe reset)
        if (slider.classList.contains("flickity-enabled")) {
          const existing = Flickity.data(slider);
          if (existing) {
            existing.destroy();
          }
        }

        // Initialize Flickity
        flickityInstance = new Flickity(slider, {
          cellAlign: "center",
          contain: true,
          wrapAround: false,
          pageDots: false,
          prevNextButtons: true,
          draggable: true,
          adaptiveHeight: true
        });

        // Important: Recalculate layout
        setTimeout(() => {
          flickityInstance.resize();
        }, 100);

      }, 2000);

    });

  });

});
}



// home mobile  curations slider

const wrapper = document.querySelector('.curations-wrapper');
const middle = document.querySelector('.curations-middle');

if (window.innerWidth <= 768 && wrapper && middle) {

  wrapper.addEventListener('scroll', () => {
    const scrollAmount = wrapper.scrollLeft;
    middle.style.setProperty(
      'transform',
      `translateX(${scrollAmount}px)`,
      'important'
    );
  }, { passive: true });

}

(function () {
  const track = document.querySelector('.top-info-bar');
  if (!track) return;
  track.style.animation = 'none';
  let pos = 0;
  let speed = 1.2;
  track.innerHTML += track.innerHTML;
  const animate = () => {
    pos -= speed;
    if (Math.abs(pos) >= track.scrollWidth / 2) {
      pos = 0;
    }
    track.style.transform = `translateX(${pos}px)`;
    requestAnimationFrame(animate);
  };
  animate();
})();

// Setter function for set height for see all button

(function () {
  const TARGET_SELECTOR = ".gview-img .gitem-img";
  const BUTTON_SELECTOR = ".tc.shop-all-button-left, .tc.shop-all-button-right";
  const BREAKPOINT = 767;

  function updateButtonHeight() {
    const isDesktop = window.innerWidth > BREAKPOINT;

    const imageEl = document.querySelector(TARGET_SELECTOR);
    const buttons = document.querySelectorAll(BUTTON_SELECTOR);

    if (!imageEl || !buttons.length) return;

    if (!isDesktop) {
      buttons.forEach(btn => {
        btn.style.maxHeight = "";
      });
      return;
    }

    const height = imageEl.getBoundingClientRect().height + 20;

    buttons.forEach(btn => {
      btn.style.maxHeight = `${height}px`;
    });
  }

  function debounce(fn, delay) {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  const debouncedUpdate = debounce(updateButtonHeight, 100);

updateButtonHeight()

  window.addEventListener("resize", debouncedUpdate);
})();


(function () {
  const mq = window.matchMedia("(min-width: 768px)");

  function applyHeight() {
    if (!mq.matches) return;

    const image = document.querySelector(".designer-image");
    const content = document.querySelector(".designer-content");

    if (!image || !content) return;

    const height = image.getBoundingClientRect().height;

    content.style.maxHeight = height + "px";
  }

  function initObserver() {
    const image = document.querySelector(".designer-image");
    if (!image) return;

    const observer = new ResizeObserver(() => {
      applyHeight();
    });

    observer.observe(image);
  }

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyHeight, 150);
  });

  function waitForImage() {
    const image = document.querySelector(".designer-image img");
    if (!image) return applyHeight();

    if (image.complete) {
      applyHeight();
    } else {
      image.addEventListener("load", applyHeight);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    waitForImage();
    initObserver();
  });
})();

document.addEventListener("click", async function (e) {
  const btn = e.target.closest(".copy-link-btn");
  if (!btn) return;

  const wrapper = btn.closest(".share-copy, .share-copy-wrapper");
  if (!wrapper) return;

  const input = wrapper.querySelector(".copy-url-input");
  const message = wrapper.querySelector(".copy-message");
  const btnText = btn.querySelector(".btn-text") || btn;

  const url = window.location.href;

  try {
    await navigator.clipboard.writeText(url);
  } catch (err) {
    if (input) {
      input.value = url;
      input.removeAttribute("readonly");
      input.select();
      document.execCommand("copy");
      input.setAttribute("readonly", true);
    }
  }

  if (btnText) btnText.innerText = "Copied ✓";
  if (message) message.style.opacity = "1";

  setTimeout(() => {
    if (btnText) btnText.innerText = "Copy";
    if (message) message.style.opacity = "0";
  }, 2000);
});

document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('click', function (e) {
    const stickyCart = e.target.closest('.showcase-cart-icon');
    
    if (stickyCart) {
      e.preventDefault();

      const originalCart = document.querySelector('.header-cart:not(.showcase-cart-icon)');
      
      if (originalCart) {
        originalCart.click();
      }
    }
  });

});

/* Filter Hide */

document.querySelectorAll('#CollectionFiltersForm .filterBox ul.widget-content li').forEach(function(li) {
  var label = li.querySelector('label');
  if (label && /cm\b/i.test(label.textContent)) {
    li.style.display = 'none';
  }
});